import I18n from 'I18n';
import PortalIdParser from 'PortalIdParser';
export const EMBED_DASHBOARD_APP_IDS = {
  KITCHEN_SINK_APP_DASHBOARD_KEY: 'KITCHEN_SINK_APP_DASHBOARD_KEY',
  CUSTOMER_SUCCESS_WORKSPACE: 'CUSTOMER_SUCCESS_WORKSPACE',
  SALES_WORKSPACE: 'SALES_WORKSPACE',
  SALES_PERFORMANCE_WORKSPACE: 'SALES_PERFORMANCE_WORKSPACE',
  CAMPAIGN_PERFORMANCE: 'CAMPAIGN_PERFORMANCE'
};
export const EMBED_DASHBOARD_APP_CONFIG = {
  [EMBED_DASHBOARD_APP_IDS.KITCHEN_SINK_APP_DASHBOARD_KEY]: {
    getAppLink() {
      return `/platform-dashboard-kitchen-sink/${PortalIdParser.get()}`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.KITCHEN_SINK_APP_DASHBOARD_KEY.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.CUSTOMER_SUCCESS_WORKSPACE]: {
    getAppLink() {
      return `/customer-success/${PortalIdParser.get()}/dashboards`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.CUSTOMER_SUCCESS_WORKSPACE.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.SALES_WORKSPACE]: {
    getAppLink() {
      return `/prospecting/${PortalIdParser.get()}/dashboards`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.SALES_WORKSPACE.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.SALES_PERFORMANCE_WORKSPACE]: {
    getAppLink() {
      return `/sales-performance/${PortalIdParser.get()}/dashboards`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.SALES_PERFORMANCE_WORKSPACE.name');
    },
    location: 'workspace'
  },
  [EMBED_DASHBOARD_APP_IDS.CAMPAIGN_PERFORMANCE]: {
    getAppLink() {
      return `/marketing/${PortalIdParser.get()}/campaigns`;
    },
    getName() {
      return I18n.text('embedDashboard.apps.CAMPAIGN_PERFORMANCE.name');
    },
    location: 'workspace'
  }
};